<template>
  <apexchart
    type="line"
    height="150"
    :options="chartOptions"
    :series="series"
  ></apexchart>
</template>

<script>
const MINUTE_MS = 60 * 1000;
const DAY_MS = 24 * 60 * MINUTE_MS;

import get from 'lodash/get';
import _ from 'lodash';

export default {
  name: 'LineChart',
  props: {
    tenant: {
      type: String,
      required: true
    },
    assetId: {
      type: String,
      required: true
    },
    maxH2: {
      type: Number,
      required: true
    },
    channelId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      measures: [],
      loading: false
    };
  },
  computed: {
    series() {
      return [
        {
          name: 'Gaz restant',
          data: this.measures.map(m => ({ x: m.timestamp, y: m.value }))
        }
      ];
    },
    chartOptions() {
      return {
        chart: {
          height: 150,
          type: 'line',
          zoom: {
            enabled: false
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: 'smooth',
          width: 2
        },
        markers: {
          size: 0
        },
        grid: {
          row: {
            colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
            opacity: 0.25
          }
        },
        tooltip: { x: { show: true, format: 'dd MMM hh:mm:ss' } },
        xaxis: {
          type: 'datetime',
          labels: {
            datetimeUTC: false
          }
        },
        yaxis: {
          decimalsInFloat: 1,
          min: 0,
          max: 100
        }
      };
    }
  },
  methods: {
    async fetch() {
      this.loading = true;

      const body = {
        query: {
          and: [
            { equals: { 'asset._id': this.assetId } },
            { equals: { 'asset.measureName': this.channelId } },
            {
              range: {
                measuredAt: {
                  gte: Date.now() - 7 * DAY_MS
                }
              }
            }
          ]
        },
        aggs: {
          measurementsOverTime: {
            date_histogram: {
              field: 'measuredAt',
              fixed_interval: '15m'
            },
            aggs: {
              average: {
                avg: {
                  field: `values.weight`
                }
              }
            }
          }
        },
        sort: {}
      };
      const searchResult = await this.$kuzzle.document.search(
        this.tenant,
        'measures',
        body,
        { lang: 'koncorde' }
      );

      this.measures = searchResult.aggregations.measurementsOverTime.buckets
        .filter(b => get(b, 'average.value', 0) > 0)
        .map(b => ({
          value:
            this.maxH2 > 0
              ? (get(b, 'average.value', 0) / this.maxH2) * 100
              : 0,
          timestamp: new Date(b.key),
          raw: {
            key: b.key,
            key_as_string: b.key_as_string
          }
        }));

      this.loading = false;
    }
  },
  mounted() {
    this.fetch();
  }
};
</script>
